import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess404053ParamStatus: 'idle',
    startProcess404053ParamError: undefined as any,
    loadUserParamsProcess404053ParamStatus: 'idle',
    loadUserParamsProcess404053ParamError: undefined as any,

    process404053ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess404053Param = createAsyncThunk('process404053ParamSlice/startProcess404053Param', async ({ process404053Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess404053Param/`,
        prepareData(process404053Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess404053ParamStatus } = getState().process404053ParamSlice
        return startProcess404053ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess404053Param = createAsyncThunk('process404053ParamSlice/loadUserParamsProcess404053Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess404053Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess404053ParamStatus } = getState().process404053ParamSlice
        return loadUserParamsProcess404053ParamStatus !== 'pending'
    }
})

const Process404053ParamSlice = createSlice({
    name: 'process404053ParamSlice',
    initialState,
    reducers: {
        resetstartProcess404053Param: (state) => {
            state.job = undefined
            state.startProcess404053ParamError = undefined
        },
        resetstartProcess404053ParamError: (state) => {
            state.startProcess404053ParamError = undefined
        },
        resetloadUserParamsProcess404053Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess404053ParamError = undefined
        },
        resetloadUserParamsProcess404053ParamError: (state) => {
            state.loadUserParamsProcess404053ParamError = undefined
        },
        removeFromProcess404053ParamListById: (state, action) => {
            state.process404053ParamList = state.process404053ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess404053ParamListByIds: (state, action) => {
            state.process404053ParamList = state.process404053ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process404053ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess404053ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process404053ParamList = []
            state.startProcess404053ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess404053Param.pending, (state) => {
            state.startProcess404053ParamStatus = 'pending'
            state.startProcess404053ParamError = undefined
        })
        builder.addCase(startProcess404053Param.fulfilled, (state, action) => {
            state.startProcess404053ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess404053Param.rejected, (state, action) => {
            state.startProcess404053ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess404053ParamError = action.error.message
            } else {
                state.startProcess404053ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess404053Param.pending, (state) => {
            state.loadUserParamsProcess404053ParamStatus = 'pending'
            state.loadUserParamsProcess404053ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess404053Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess404053ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess404053Param.rejected, (state, action) => {
            state.loadUserParamsProcess404053ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess404053ParamError = action.error.message
            } else {
                state.loadUserParamsProcess404053ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess404053Param,
    resetstartProcess404053ParamError,
    resetloadUserParamsProcess404053Param,
    resetloadUserParamsProcess404053ParamError,
    removeFromProcess404053ParamListById,
    removeFromProcess404053ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process404053ParamSlice.actions
export default Process404053ParamSlice.reducer
